<template>
  <v-dialog v-model="dialogshowimage" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card style="background-color: rgba(0, 0, 0, 0.9);">
      <v-toolbar dark style="background-color: #1b232d;">
         <v-flex xl1 lg1 md1 sm1 style="text-align: right; padding-right: 2vw;">
        <v-avatar class="user-photo" style="cursor: pointer;">
          <!-- <img v-if="DetailImage.path_pic !== ''" :src="DetailImage.path_pic" class="alligator-turtle"> -->
          <!-- <img v-else-if="DetailImage.typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
          <img v-else-if="DetailImage.typeuser === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle"> -->
          <!-- <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle"> -->
        </v-avatar>
      </v-flex>
      <v-flex xl6 lg6 md6 sm6>
        <!-- <b style="font-size: 14px;"> {{DetailImage.file_name}} </b>
        <p style="font-size: 12px; margin-bottom: 0px;"> ส่งโดย {{DetailImage.nickname}} &nbsp;&nbsp;| &nbsp;{{date(DetailImage.timestamp)}}
          <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{time(DetailImage.timestamp)}}
        </p> -->
      </v-flex>
      <v-flex xl4 lg4 md4 sm4 style="text-align: right;">
        <!-- <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic(DetailImage.file_name)">
          <v-icon>file_download</v-icon>&nbsp; บันทึก
        </v-btn> -->
        <!-- <v-btn depressed small class="btncancel CSChatThai" @click="sendonebox(DetailImage.tokenmessage)">
          <v-icon>cloud_upload</v-icon> &nbsp; {{$t('AnswerQuestion.sendOnebox')}}
        </v-btn> -->
      </v-flex>
     <v-flex xl1 lg1 md1 sm1 style="text-align: right;">
      <v-btn icon @click="closeDialogShowImage">
        <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
      </v-btn>
      </v-flex>

      </v-toolbar>
      <div style="background: none; height: 100vh; overflow-y: hidden !important;">
        <img v-if="DetailImage.typeofmessage === 'image'" class="modal-contentc" :src="DetailImage.message">
        <iframe v-else-if="DetailImage.typeofmessage === 'file'" :src="DetailImage.message" style="width: 100%; height: 100%; justify-content: center;" frameborder="0"></iframe>
        <vplayer
          v-else-if="DetailImage.typeofmessage === 'video'"
          :playerOptions="{
            type: 'application/x-mpegURL',
            src: DetailImage.message,
            preload: true,
            autoplay: false,
            isLoop: false,
            playsinline: false,
            poster: DetailImage.thumbnail,
            controls: 'progress,current,durration,volume',
            crossOrigin: false
          }"
          @onplay="play"
          class="modal-contentc"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Momenttime, Decode } from '@/services'
import { vplayer } from 'vue-hls-player'

export default {
  props: {
    dialogshowimage: Boolean,
    DetailImage: {}
  },
  data: () => ({
    token: '',
    dialogshowimage_profile: false,
    pathpicture: '',
    typepathpicture: '',
    dialogSaveOnebox: false,
    tokenmessage_savebox: ''
  }),
  computed: {
    ...sync('*')
  },
  watch: {
    dialogshowimage () {
      if (this.dialogshowimage) {
        // console.log(this.DetailImage)
      }
    }
  },
  methods: {
    play (e) {
      console.log(e)
    },
    openPictureProfile (picture, type) {
      this.pathpicture = picture
      this.typepathpicture = type
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    loadpic (filenameSend) {
      this.axios.get(this.DetailImage.message, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    sendonebox (tokenmessage) {
      this.dialogSaveOnebox = true
      this.tokenmessage_savebox = tokenmessage
    },
    closeSaveOnebox (value) {
      this.dialogSaveOnebox = value
    },
    closeDialogShowImage () {
      this.$emit('closeDialogShowImage', false)
    },
    date (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    }
  },
  created () {
    // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
  },
  components: {
    vplayer
  }
}
</script>
<style scoped>
>>>.v-dialog--fullscreen {
    border-radius: 0;
    margin: 0;
    height: 100%;
    position: fixed;
    overflow-y: hidden;
    top: 0;
    left: 0;
}
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  max-width: 80%;
  width: auto;
  height: 70vh;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
  text-transform: none;
}

.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
  text-transform: none;
}
.CSChatThai{
  font-family: 'CS ChatThaiUI', sans-serif !important;
}
</style>
